const kenya = {
  Mombasa: [
    "Mombasa",
    "Likoni",
    "Kisauni",
    "Changamwe",
    "Nyali",
    "Bamburi",
  ],


  Kwale: [
    "Kwale",
    "Ukunda",
    "Msambweni",
    "Lunga Lunga",
    "Kinango",
  ],

  Kilifi: [
    "Kilifi",
    "Malindi",
    "Watamu",
    "Mariakani",
    "Mtwapa",
  ],

  TanaRiver: [
    "Hola",
    "Bura",
    "Garsen",
  ],

  Lamu: [
    "Lamu",
    "Mpeketoni",
    "Faza",
  ],

  TaitaTaveta: [
    "Voi",
    "Taveta",
    "Wundanyi",
    "Mwatate",
  ],

  Garissa: [
    "Garissa",
    "Dadaab",
    "Ijara",
    "Modogashe",
  ],

  Wajir: [
    "Wajir",
    "Habaswein",
    "Griftu",
  ],

  Mandera: [
    "Mandera",
    "El Wak",
    "Rhamu",
  ],

  Marsabit: [
    "Marsabit",
    "Moyale",
    "Laisamis",
  ],

  Isiolo: [
    "Isiolo",
    "Garbatulla",
    "Merti",
  ],

  Meru: [
    "Meru",
    "Maua",
    "Nkubu",
    "Timau",
  ],

  TharakaNithi: [
    "Chuka",
    "Kathwana",
    "Marimanti",
  ],

  Embu: [
    "Embu",
    "Runyenjes",
    "Manyatta",
  ],

  Kitui: [
    "Kitui",
    "Mwingi",
    "Mutomo",
    "Ikutha",
  ],

  Machakos: [
    "Machakos",
    "Athi River",
    "Mlolongo",
    "Kangundo",
  ],

  Makueni: [
    "Wote",
    "Makindu",
    "Emali",
    "Sultan Hamud",
  ],

  Nyandarua: [
    "Ol Kalou",
    "Engineer",
    "Njabini",
  ],

  Nyeri: [
    "Nyeri",
    "Karatina",
    "Othaya",
    "Naro Moru",
  ],

  Kirinyaga: [
    "Kerugoya",
    "Kutus",
    "Sagana",
  ],

  Muranga: [
    "Murang'a",
    "Kangema",
    "Maragua",
    "Kenol",
  ],

  Kiambu: [
    "Kiambu",
    "Thika",
    "Ruiru",
    "Limuru",
    "Kikuyu",
    "Juja",
    "Githunguri",
  ],

  Turkana: [
    "Lodwar",
    "Lokichogio",
    "Kakuma",
  ],

  WestPokot: [
    "Kapenguria",
    "Makutano",
    "Chepareria",
  ],

  Samburu: [
    "Maralal",
    "Baragoi",
    "Wamba",
  ],

  TransNzoia: [
    "Kitale",
    "Endebess",
    "Kiminini",
  ],

  UasinGishu: [
    "Eldoret",
    "Burnt Forest",
    "Turbo",
  ],

  ElgeyoMarakwet: [
    "Iten",
    "Kapsowar",
    "Chebara",
  ],

  Nandi: [
    "Kapsabet",
    "Nandi Hills",
    "Mosoriot",
  ],

  Baringo: [
    "Kabarnet",
    "Marigat",
    "Eldama Ravine",
  ],

  Laikipia: [
    "Nanyuki",
    "Nyahururu",
    "Rumuruti",
  ],

  Nakuru: [
    "Nakuru",
    "Naivasha",
    "Molo",
    "Gilgil",
    "Njoro",
  ],

  Narok: [
    "Narok",
    "Kilgoris",
    "Suswa",
  ],

  Kajiado: [
    "Kajiado",
    "Kitengela",
    "Ngong",
    "Ongata Rongai",
    "Loitokitok",
  ],

  Kericho: [
    "Kericho",
    "Litein",
    "Londiani",
  ],

  Bomet: [
    "Bomet",
    "Sotik",
    "Longisa",
  ],

  Kakamega: [
    "Kakamega",
    "Mumias",
    "Lugari",
  ],

  Vihiga: [
    "Mbale",
    "Luanda",
    "Chavakali",
  ],

  Bungoma: [
    "Bungoma",
    "Webuye",
    "Kimilili",
  ],

  Busia: [
    "Busia",
    "Malaba",
    "Funyula",
  ],

  Siaya: [
    "Siaya",
    "Bondo",
    "Ugunja",
  ],

  Kisumu: [
    "Kisumu",
    "Ahero",
    "Maseno",
  ],

  HomaBay: [
    "Homa Bay",
    "Mbita",
    "Oyugis",
  ],

  Migori: [
    "Migori",
    "Kehancha",
    "Rongo",
  ],

  Kisii: [
    "Kisii",
    "Ogembo",
    "Suneka",
  ],

  Nyamira: [
    "Nyamira",
    "Keroka",
    "Nyansiongo",
  ],

  Nairobi: [
    "Nairobi CBD",
    "Westlands",
    "Kilimani",
    "Karen",
    "Lang'ata",
    "Embakasi",
    "Kasarani",
    "Eastleigh",
    "South B",
    "South C",
  ],
};

export default kenya;